import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Typography,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Box,
} from "@mui/material";

const UserVideoPage = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const selectedSubject = "FREE";

  useEffect(() => {
    fetchVideos();
  }, []);

  const fetchVideos = async () => {
    try {
      const res = await axios.get(
        `https://userspeedacademy.vebbox.in/speedbackend/controllers/api/User/get/U_VideoPg.php?category=${selectedSubject}`
      );
      setVideos(res.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching videos:", error);
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{ padding: "3rem", backgroundColor: "#f9f9f9", minHeight: "100vh" }}
    >
      <Typography
        variant="h3"
        align="center"
        gutterBottom
        sx={{ fontWeight: "bold", marginBottom: "2rem" }}
      >
        {selectedSubject} Video Lectures
      </Typography>

      {loading ? (
        <Box
          sx={{ display: "flex", justifyContent: "center", marginTop: "3rem" }}
        >
          <CircularProgress />
        </Box>
      ) : videos.length === 0 ? (
        <Typography align="center" color="textSecondary" variant="h6">
          No videos available for {selectedSubject}.
        </Typography>
      ) : (
        <Grid container spacing={6} justifyContent="center">
          {videos.map((video) => (
            <Grid item xs={12} sm={10} md={8} lg={6} key={video.id}>
              <Card
                sx={{
                  boxShadow: 6,
                  borderRadius: "16px",
                  overflow: "hidden",
                }}
              >
                <video
                  width="100%"
                  height="400"
                  controls
                  style={{ backgroundColor: "#000" }}
                  onContextMenu={(e) => e.preventDefault()}
                  src={video.video_path}
                >
                  Your browser does not support the video tag.
                </video>
                <CardContent sx={{ padding: "1.5rem" }}>
                  <Typography variant="h5" sx={{ fontWeight: 600 }}>
                    {video.title}
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    {video.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default UserVideoPage;
